import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onClientEntry = () => {
  if (typeof document === "undefined") return
  document.documentElement.classList.add("js")
}

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return

  // =========================
  // 1) fadeInUp（既存）
  // =========================
  const fadeTargets = document.querySelectorAll(".fadeInUp")
  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add("on")
        fadeObserver.unobserve(entry.target) // 1回だけ
      })
    },
    { threshold: 0.1 }
  )
  fadeTargets.forEach((el) => fadeObserver.observe(el))

  // =========================
  // 2) js-reveal（追加）
  // =========================
  const revealTargets = document.querySelectorAll(".js-reveal")
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        // 描画→次フレームで付与（初期表示でも確実にアニメ）
        requestAnimationFrame(() => entry.target.classList.add("is-in"))
        revealObserver.unobserve(entry.target) // 1回だけ
      })
    },
    { threshold: 0.25 }
  )
  revealTargets.forEach((el) => revealObserver.observe(el))

  // =========================
  // 3) comVisual（KV専用）
  //    画面内に最初からいるので即付与だとアニメしない事がある
  // =========================
  const comVisuals = document.querySelectorAll(".comVisual")
  comVisuals.forEach((el) => {
    requestAnimationFrame(() => el.classList.add("is-in"))
  })

  // ルート遷移のたびに作るので軽く掃除（任意だけどおすすめ）
  return () => {
    fadeObserver.disconnect()
    revealObserver.disconnect()
  }
}
